import { PostResetPassword } from "./ApiCalls/ResetPassword/PostResetPassword";
import { PatchPasswordUser } from "./ApiCalls/ResetPassword/PatchPasswordUser";
export async function PostResetPasswordService(mail) {
    try {
        const resetPasswordData = await PostResetPassword(mail);

        return resetPasswordData;

    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error
        throw error;
    }
}

export async function PatchPasswordUserService(idUSer, idRequest, password) {
    try {
        const userResetPassword = await PatchPasswordUser(idUSer, idRequest, password);

    return userResetPassword;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}